export const isHideCombosActiveKey: InjectionKey<ComputedRef<boolean>> =
  Symbol('isHideCombosActive')
